
import Vue from "vue";

function replaceSubNumber(value: String) {
  value = value.replace(/₀/g, "0");
  value = value.replace(/₁/g, "1");
  value = value.replace(/₂/g, "2");
  value = value.replace(/₃/g, "3");
  value = value.replace(/₄/g, "4");
  value = value.replace(/₅/g, "5");
  value = value.replace(/₆/g, "6");
  value = value.replace(/₇/g, "7");
  value = value.replace(/₈/g, "8");
  value = value.replace(/₉/g, "9");
  value = value.replace(/ₓ/g, "x");
  return value;
}

export default Vue.extend({
  name: "TransLiteral",
  props: {
    word: String,
  },
  computed: {
    suptext(): String {
      if (!this.word) return "";

      var match = replaceSubNumber(this.word).match(/\{(.+)\}/);
      return match ? match[1] : "";
    },
    subtext(): String {
      if (!this.word) return "";

      var match = replaceSubNumber(this.word).match(/.(\d+)$/);
      return match ? match[1] : "";
    },
    basetext(): String {
      if (!this.word) return "";

      var val = this.word.replace(/\{.+\}/, "");

      if (this.subtext) {
        return val.slice(0, -this.subtext.length);
      } else {
        return val;
      }
    },
  },
});
